export default {
	dark: false,
	themes: {
		light: {
			primary: '#145cff',
			error: '#b00020',
			accent: '#145cff'
		},
		dark: {
			primary: '#145cff',
			error: '#b00020',
			accent: '#145cff'
		}
	}
};



// WEBPACK FOOTER //
// ./app/mixins/theme.js